module.exports = __webpack_public_path__ + "account/assets/3.ceef82f5.svg";